var map = {
	"./badge_proofpoints-light.de.html": [
		612,
		612
	],
	"./badge_proofpoints-light.en.html": [
		392,
		392
	],
	"./badge_proofpoints-light.es.html": [
		283,
		283
	],
	"./badge_proofpoints-light.fr.html": [
		923,
		923
	],
	"./badge_proofpoints-light.nl.html": [
		389,
		389
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 629;
module.exports = webpackAsyncContext;